import React from 'react';
import QAndA from '../../../components/QAndA/QAndA';

export default (props) => <QAndA qAndAData={props} />;
